import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

export default function ApproveTreatmentModal({ open, onClose, onConfirm, treatmentDescription }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle id="confirm-dialog-title">
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Você realmente deseja aprovar o tratamento?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          Após aprovado, o tratamento e seus procedimentos não poderão ser alterados.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
          Aprovar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
